import { Paper, Text } from "@mantine/core";
import { Link } from "react-router-dom";

export function StatCard({
  title,
  value,
  color,
  subtitle,
  to,
}: {
  title: string;
  value: string | number;
  color: string;
  subtitle?: string;
  to?: string;
}) {
  const content = (
    <>
      <Text size="xs" color="dimmed" tt="uppercase" fw={700}>
        {title}
      </Text>
      <Text size="xl" fw={700} color={color} mt={4}>
        {value}
      </Text>
      {subtitle && (
        <Text size="xs" color="dimmed" mt={4}>
          {subtitle}
        </Text>
      )}
    </>
  );

  if (to) {
    return (
      <Paper
        component={Link}
        to={to}
        p="md"
        radius="md"
        withBorder
        sx={(theme) => ({
          height: "100%",
          display: "block",
          textDecoration: "none",
          "&:hover": {
            borderColor: theme.colors[color]?.[5] ?? theme.colors.blue[5],
            boxShadow: theme.shadows.xs,
          },
        })}
      >
        {content}
      </Paper>
    );
  }

  return (
    <Paper p="md" radius="md" withBorder sx={{ height: "100%" }}>
      {content}
    </Paper>
  );
}
